<template>
  <SecurityManagementTableBase
    :title="$t('security.permissionMatrix.tableTitle')"
    icon="cil-list-rich"
    :items="items"
    :fields="fields"
    :show-add="false"
    :small="true"
    :items-per-page="20"
    :scoped-slot-names="['source', 'all', 'view', 'edit', 'delete', 'action', 'owner', 'logs']"
  >
    <template #header-actions>
      <slot name="header-actions" />
    </template>

    <template #actions>
    </template>

    <template #source="{ item }">
      <td>
        <CBadge :color="item.source === 'mapped' ? 'info' : 'success'">
          {{ item.source === 'mapped' ? 'Mapped' : 'Manual' }}
        </CBadge>
      </td>
    </template>

    <template #all="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--all"
          :class="{ 'permission-toggle--checked': item.all }"
          :aria-pressed="item.all ? 'true' : 'false'"
          aria-label="Toggle all permissions"
          @click="$emit('toggle', item, 'all', !item.all)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

    <template #view="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--view"
          :class="{ 'permission-toggle--checked': item.view }"
          :aria-pressed="item.view ? 'true' : 'false'"
          aria-label="Toggle view permission"
          @click="$emit('toggle', item, 'view', !item.view)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

    <template #edit="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--edit"
          :class="{ 'permission-toggle--checked': item.edit }"
          :aria-pressed="item.edit ? 'true' : 'false'"
          aria-label="Toggle edit permission"
          @click="$emit('toggle', item, 'edit', !item.edit)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

    <template #delete="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--delete"
          :class="{ 'permission-toggle--checked': item.delete }"
          :aria-pressed="item.delete ? 'true' : 'false'"
          aria-label="Toggle delete permission"
          @click="$emit('toggle', item, 'delete', !item.delete)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

    <template #action="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--action"
          :class="{ 'permission-toggle--checked': item.action }"
          :aria-pressed="item.action ? 'true' : 'false'"
          aria-label="Toggle action permission"
          @click="$emit('toggle', item, 'action', !item.action)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

    <template #owner="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--owner"
          :class="{ 'permission-toggle--checked': item.owner }"
          :aria-pressed="item.owner ? 'true' : 'false'"
          aria-label="Toggle owner permission"
          @click="$emit('toggle', item, 'owner', !item.owner)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

    <template #logs="{ item }">
      <td class="text-center">
        <button
          type="button"
          class="permission-toggle permission-toggle--logs"
          :class="{ 'permission-toggle--checked': item.logs }"
          :aria-pressed="item.logs ? 'true' : 'false'"
          aria-label="Toggle logs permission"
          @click="$emit('toggle', item, 'logs', !item.logs)"
        >
          <span class="permission-toggle__dot"></span>
        </button>
      </td>
    </template>

  </SecurityManagementTableBase>
</template>

<script>
import SecurityManagementTableBase from '@/projects/views/security/components/SecurityManagementTableBase'

export default {
  name: 'PermissionMatrixTable',
  components: { SecurityManagementTableBase },
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] }
  }
}
</script>

<style scoped lang="scss">
@import "../security-page.shared";

.permission-toggle {
  --permission-color: #9e212f;

  align-items: center;
  background: rgba(148, 163, 184, 0.12);
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  height: 26px;
  justify-content: flex-start;
  padding: 3px;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  width: 48px;
}

.permission-toggle:focus {
  box-shadow: 0 0 0 3px rgba(158, 33, 47, 0.16);
  outline: none;
}

.permission-toggle:hover {
  border-color: var(--permission-color);
}

.permission-toggle__dot {
  background: #ffffff;
  border: 2px solid rgba(100, 116, 139, 0.35);
  border-radius: 50%;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.16);
  display: block;
  height: 20px;
  transform: translateX(0);
  transition: transform 0.18s ease, border-color 0.18s ease;
  width: 20px;
}

.permission-toggle--checked {
  background: var(--permission-color);
  border-color: var(--permission-color);
}

.permission-toggle--checked .permission-toggle__dot {
  border-color: #ffffff;
  transform: translateX(22px);
}

.permission-toggle--all {
  --permission-color: #9e212f;
}

.permission-toggle--view {
  --permission-color: #0ea5e9;
}

.permission-toggle--edit {
  --permission-color: #f59e0b;
}

.permission-toggle--delete {
  --permission-color: #dc2626;
}

.permission-toggle--action {
  --permission-color: #16a34a;
}

.permission-toggle--owner {
  --permission-color: #334155;
}

.permission-toggle--logs {
  --permission-color: #64748b;
}
</style>
